import { Box, LinearProgress, Typography } from "@mui/material";

const ProgressBar = ({ title, value }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      width: "100%",
      gap: 2,
      "@media print": {
        gap: 1,
      },
    }}
  >
    <Box
      sx={{
        minWidth: title ? 100 : 0,
        "@media print": {
          minWidth: title ? 80 : 0,
        },
      }}
    >
      {title && (
        <Typography
          sx={{
            fontSize: "1rem",
            fontWeight: "500",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100px",
            "@media print": {
              fontSize: "0.875rem",
              width: "100px",
            },
          }}
        >
          {title}
        </Typography>
      )}
    </Box>
    <Box sx={{ flex: 1 }}>
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          height: "1.25rem",
          borderRadius: "999px",
          backgroundColor: "grey.200",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "colors.textVibrantGreen",
            borderRadius: "999px",
          },
          border: "none !important",
          "@media print": {
            height: "1rem",
          },
        }}
      />
    </Box>
    <Box
      sx={{
        width: "2rem",
        textAlign: "right",
        "@media print": {
          width: "1.5rem",
        },
      }}
    >
      <Typography
        sx={{
          fontSize: "1rem",
          fontWeight: "500",
          "@media print": {
            fontSize: "0.875rem",
          },
        }}
      >
        {value}%
      </Typography>
    </Box>
  </Box>
);

export default ProgressBar;
